import React, { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Input, Button, Modal, Row, Col, Collapse } from "antd";
import _ from "lodash";
import "./index.scss";
import { useDispatch } from "react-redux";
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  PaymentElement,
  Elements
} from "@stripe/react-stripe-js";
import {loadStripe} from '@stripe/stripe-js';
import { useStripe, useElements } from "@stripe/react-stripe-js";
import { pushNotification } from "utils/notifications";


const { Panel } = Collapse;

const SaveCardModal: FC<{ lastSetupIntent?: any; onClose: () => void; onAdd?: any }> = ({ lastSetupIntent, onClose, onAdd }) => {
  const dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = useState<boolean>(true);
  const [saving, setSaving] = useState<boolean>(false);

  // const stripeKey: string = process.env.REACT_APP_STRIPE_KEY || "";
  // const stripePromise = loadStripe(stripeKey);

  const stripe = useStripe();
  const elements = useElements();

  const CARD_ELEMENT_OPTIONS = {
    style: {
      base: {
        color: "#32325d",
        fontSize: "16px",
        "::placeholder": {
          color: "#aab7c4",
        },
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a",
      },
    },
  };


  const handleCancel = () => {
    onClose && onClose();
  };

  const handleOk = () => {
    onClose && onClose();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // console.log('response', event);

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make  sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setSaving(true);

    // const card = elements.getElement(CardNumberElement);
    // const result = await stripe.createSource(card, { type: "card" });


    const {error} = await stripe.confirmSetup({
      //`Elements` instance that was used to create the Payment Element
      elements,
      confirmParams: {
        return_url: window.location.href,
      },
    });

    if (error) {
      // This point will only be reached if there is an immediate error when
      // confirming the payment. Show error to your customer (for example, payment
      // details incomplete)
      // setErrorMessage(error.message);
      console.log('error message', error.message);
      setSaving(false);
      pushNotification(error.message, "error", "TOP_CENTER", 3000);
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
    }

    // if (result.error) {
    //   // Show error to your customer.
    //   console.log(result.error.message);
    // } else {
    //   // Send the token to your server.
    //   // This function does not exist yet; we will define it in the next step.
    //   //   stripeTokenHandler(result.token);
    //   console.log("source", result);
    //   onAdd && onAdd(result)
    // }
  };

  return (
    <Modal
      title="New card"
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width="480px"
      className="beam-modal"
      footer={[]}
      destroyOnClose={true}
    >
      <form onSubmit={handleSubmit}>
        <div className="mt-2" style={{height: 500}}>
          {/* <Col span={24} className="mb-2">
            <CardNumberElement options={CARD_ELEMENT_OPTIONS} />
          </Col>

          <Col span={24} className="mb-2">
            <CardExpiryElement options={CARD_ELEMENT_OPTIONS} />
          </Col>

          <Col span={24} className="mb-2">
            <CardCvcElement options={CARD_ELEMENT_OPTIONS} />
          </Col> */}

          {/* <Col span={24}> */}
            {/* <Elements stripe={stripePromise} options={{
              clientSecret: lastSetupIntent.client_secret
            }}> */}
            <PaymentElement/>
            {/* </Elements> */}
          {/* </Col> */}
        </div>

        <Row className="action-grp mt-4">
          <Col span={14} className="pr-2">
            <Button
              className="beam-btn green-btn cover w-full"
              htmlType="submit"
              loading={saving}
            // onClick={handleOk}
            >
              Save
            </Button>
          </Col>
          <Col span={10} className="pl-2">
            <Button
              className="beam-btn orange-btn bordered w-full"
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </Col>
        </Row>
      </form>
    </Modal>
  );
};

export default SaveCardModal;
